export default "__VITE_ASSET__cbf29b7c__"